import * as actionTypes from "./types";
import { createReducer } from "../../../utils";

const initialState = {
  items: [],
  products: [],
  ingredients: [],
  pictos: [],
  isLoading: false,
  isLoadingProducts: false,
  isLoadingIngredients: false,
};

const productSuggestionsReducer = createReducer(initialState)({
  [actionTypes.PRODUCT_SUGG_PRODUCTS]: (state) => ({ ...state, isLoadingProducts: true }),
  [actionTypes.PRODUCT_SUGG_PRODUCTS_COMPLETED]: (state, action) => ({
    ...state,
    isLoadingProducts: false,
    products: (action.payload.result && action.payload.result.items) || [],
  }),
  [actionTypes.PRODUCT_SUGG_PRODUCTS_FAILED]: (state) => ({ ...state, isLoadingProducts: false }),

  [actionTypes.PRODUCT_SUGG_LIST]: (state) => ({ ...state, isLoading: true }),
  [actionTypes.PRODUCT_SUGG_LIST_COMPLETED]: (state, action) => ({
    ...state,
    isLoading: false,
    // L'API renvoie {items:[...]} ; le wrapper global + apiService exposent
    // le corps via action.payload.result.
    items: (action.payload.result && action.payload.result.items) || [],
  }),
  [actionTypes.PRODUCT_SUGG_LIST_FAILED]: (state) => ({ ...state, isLoading: false }),

  [actionTypes.PRODUCT_SUGG_INGREDIENTS]: (state) => ({ ...state, isLoadingIngredients: true }),
  [actionTypes.PRODUCT_SUGG_INGREDIENTS_COMPLETED]: (state, action) => ({
    ...state,
    isLoadingIngredients: false,
    ingredients: (action.payload.result && action.payload.result.items) || [],
  }),
  [actionTypes.PRODUCT_SUGG_INGREDIENTS_FAILED]: (state) => ({ ...state, isLoadingIngredients: false }),

  [actionTypes.PRODUCT_SUGG_PICTOS_COMPLETED]: (state, action) => ({
    ...state,
    pictos: (action.payload.result && action.payload.result.items) || [],
  }),

  [actionTypes.PRODUCT_SUGG_CREATE_COMPLETED]: (state, action) => ({
    ...state,
    // Ajout en fin de liste, comme le renverrait le serveur (Product::$suggestions
    // trié par `sort` ASC). Le panneau réordonne ensuite alphabétiquement à
    // l'affichage : la carte se place directement à sa place définitive.
    items: [...state.items, action.payload.result.item],
  }),

  [actionTypes.PRODUCT_SUGG_UPDATE_COMPLETED]: (state, action) => ({
    ...state,
    items: state.items.map((i) =>
      i.id === action.payload.result.item.id ? action.payload.result.item : i
    ),
  }),

  [actionTypes.PRODUCT_SUGG_DELETE_COMPLETED]: (state, action) => ({
    ...state,
    items: state.items.filter((i) => i.id !== action.payload.id),
  }),
});

export default productSuggestionsReducer;
